export default {
  userList: [],
  loading: false,
  error: "",
  hasError: false,
  errorDuration: 2500,
};
